<div class="app-root-container">

  @if (isBarMenuShown(outlet) && mediaQuery.isDesktop()) {
    <app-top-bar></app-top-bar>
  }

  <div [@routeAnimations]="prepareRoute(outlet)" class="app-container" [ngClass]="{'bar-menu-shown': isBarMenuShown(outlet), 'embedded': isEmbedded}">
    <router-outlet #outlet="outlet" (activate)="onActivate($event, '.app-container')"></router-outlet>
  </div>

  @if (isBarMenuShown(outlet) && !mediaQuery.isDesktop()) {
    <app-bar [state]="barMenu"></app-bar>
  }

  <!-- Panier embedded-->
  @if (isCartFloatingButtonShown(outlet)) {
    <button mat-fab color="primary" class="floating-panel" (click)="onPanelClick()">
      <mat-icon svgIcon="shopping-basket" color="white" [matBadge]="cartBadgeValue$ | async" matBadgeColor="accent" matBadgeSize="small" [matBadgeHidden]="(cartBadgeValue$ | async) < 1">
      </mat-icon>
    </button>
  }

</div>
